import { render, staticRenderFns } from "./Pagination03.vue?vue&type=template&id=98c6690e"
import script from "./Pagination03.vue?vue&type=script&lang=js"
export * from "./Pagination03.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports